/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Situationreviewtimeline2Inputs */

const en_situationreviewtimeline2 = /** @type {(inputs: Situationreviewtimeline2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Review the timeline`)
};

const pt_situationreviewtimeline2 = /** @type {(inputs: Situationreviewtimeline2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rever a cronologia`)
};

/**
* | output |
* | --- |
* | "Review the timeline" |
*
* @param {Situationreviewtimeline2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const situationreviewtimeline2 = /** @type {((inputs?: Situationreviewtimeline2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Situationreviewtimeline2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_situationreviewtimeline2(inputs)
	return pt_situationreviewtimeline2(inputs)
});
export { situationreviewtimeline2 as "situationReviewTimeline" }